import React, { Component } from "react";
import Reset from "~/scripts/components/products/Reset";

class NoResults extends Component {
    render() {
        return (
            <div className="no-results">
                <div className="no-results__message">
                    Sorry, there are no results that match your query.
                </div>
                <div className="no-results__link">
                    <Reset
                        linkText="Click here to start again."
                        clearsQuery={true}
                    />
                </div>
            </div>
        );
    }
}

export default NoResults;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/NoResults.js